/** Stable, versioned runtime contract for the generated Foam Pop pixel art. */
export const FOAM_POP_TEXTURE_KEYS = Object.freeze({
  backgroundLandscape: "foam-pop-v1-background-landscape",
  backgroundPortrait: "foam-pop-v1-background-portrait",
  mascot: "foam-pop-v1-yaong",
  mascotWheel: "foam-pop-v2-yaong-wheel",
  bubbles: "foam-pop-v1-bubbles"
});

export const FOAM_POP_ASSET_PATHS = Object.freeze({
  backgroundLandscape: "/assets/foam-pop/v1/environment/foam-workshop-landscape.png",
  backgroundPortrait: "/assets/foam-pop/v1/environment/foam-workshop-portrait.png",
  mascot: "/assets/foam-pop/v1/characters/yaong-atlas.png",
  mascotWheel: "/assets/foam-pop/v2/characters/yaong-wheel-atlas.png",
  bubbles: "/assets/foam-pop/v1/bubbles/bubbles-atlas.png"
});

export const FOAM_POP_MASCOT_FRAME = Object.freeze({
  idle: 0,
  aimLeft: 1,
  aimUp: 2,
  aimRight: 3,
  fire: 4,
  hold: 5,
  cheer: 6,
  danger: 7
});

export const FOAM_POP_MASCOT_SHEET = Object.freeze({
  width: 1024,
  height: 512,
  frameWidth: 256,
  frameHeight: 256
});

/**
 * Yaong operating an original wooden/brass foam-launcher helm. Frames 0–6
 * progress from hard left to hard right; 8–11 are wind-up, lever, fire, recover.
 */
export const FOAM_POP_WHEEL_MASCOT_FRAME = Object.freeze({
  hardLeft: 0,
  left: 1,
  softLeft: 2,
  center: 3,
  softRight: 4,
  right: 5,
  hardRight: 6,
  ready: 7,
  windUp: 8,
  lever: 9,
  fire: 10,
  recover: 11
});

export const FOAM_POP_WHEEL_MASCOT_SHEET = Object.freeze({
  width: 1024,
  height: 768,
  frameWidth: 256,
  frameHeight: 256
});

export const FOAM_POP_WHEEL_FIRE_ANIMATION_KEY = "foam-pop-v2-yaong-wheel-fire";

/** Seven-step helm pose lookup used by keyboard, touch drag, and remote aim. */
export function foamPopWheelAimFrame(aim: number): number {
  if (aim <= -52) return FOAM_POP_WHEEL_MASCOT_FRAME.hardLeft;
  if (aim <= -30) return FOAM_POP_WHEEL_MASCOT_FRAME.left;
  if (aim <= -10) return FOAM_POP_WHEEL_MASCOT_FRAME.softLeft;
  if (aim < 10) return FOAM_POP_WHEEL_MASCOT_FRAME.center;
  if (aim < 30) return FOAM_POP_WHEEL_MASCOT_FRAME.softRight;
  if (aim < 52) return FOAM_POP_WHEEL_MASCOT_FRAME.right;
  return FOAM_POP_WHEEL_MASCOT_FRAME.hardRight;
}

export const FOAM_POP_BUBBLE_SHEET = Object.freeze({
  width: 320,
  height: 256,
  frameWidth: 64,
  frameHeight: 64,
  columns: 5,
  rows: 4
});

const BUBBLE_COLOR_COLUMN: Readonly<Record<string, number>> = Object.freeze({
  cyan: 0,
  blue: 0,
  coral: 1,
  orange: 1,
  pink: 1,
  lime: 2,
  green: 2,
  violet: 3,
  purple: 3,
  gold: 4,
  yellow: 4
});

const BUBBLE_KIND_ROW: Readonly<Record<string, number>> = Object.freeze({
  normal: 0,
  color_burst: 1,
  row_burst: 2,
  column_burst: 3
});

/** Row-major frame lookup for the 5-column by 4-row bubble sheet. */
export function foamPopBubbleFrame(color: string, kind: string): number {
  const column = BUBBLE_COLOR_COLUMN[color.toLowerCase()] ?? 0;
  const row = BUBBLE_KIND_ROW[kind.toLowerCase()] ?? 0;
  return row * FOAM_POP_BUBBLE_SHEET.columns + column;
}
